import PersonalInfo from "./PersonalInfo";
import Preferences from "./Preferences";
import DangerZone from "./DangerZone";

const accountComponents = {
  PersonalInfo,
  Preferences,
  DangerZone
}

export default accountComponents